import { render, staticRenderFns } from "./JdSkuInfoSimpleCard.vue?vue&type=template&id=c9401ff0&scoped=true&"
import script from "./JdSkuInfoSimpleCard.vue?vue&type=script&lang=js&"
export * from "./JdSkuInfoSimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./JdSkuInfoSimpleCard.vue?vue&type=style&index=0&id=c9401ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9401ff0",
  null
  
)

export default component.exports